import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './header-search-results.module.scss'
import { Link } from 'react-router-dom'

/**
 * Контент результата поиска, который можно использовать и в dropdown, и в мобильном модальном листе.
 */
export const HeaderSearchResults = ({
  title,
  items = [],
  className,
  onClickItem,
  emptyText = 'Начните вводить запрос',
}) => {
  const hasData = items?.length

  if (!hasData) {
    return <div className={cls.empty}>{emptyText}</div>
  }

  return (
    <div className={classNames(cls.results, className)}>
      {title && <div className={cls.sectionTitle}>{title}</div>}
      <div className={cls.items}>
        {items?.map(item => (
          <Link
            key={item.id || item.title}
            to={item.slug}
            className={cls.item}
            onClick={onClickItem(item)}
          >
            <div className={cls.itemTitle}>{item.title}</div>
            {item.sectionName && <span className={cls.itemTag}>{item.sectionName}</span>}
          </Link>
        ))}
      </div>
    </div>
  )
}

HeaderSearchResults.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      tag: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  emptyText: PropTypes.string,
}
